import classNames from "classnames";
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { StateContext } from "../../context/stateContext";
import { translations } from "../../translate";
import styles from "./Footer.module.scss";

export type footerType = {
  classes?: {
    linkClassName?: string;
    textClassName?: string;
    footerContent?: string;
  };
  footer?: React.ReactNode;
  fullWidthFooter?: string | React.ReactNode;
  desktopLeftFooter?: string | React.ReactNode;
};

const Footer: React.FC<footerType> = ({ classes, footer, fullWidthFooter = false, desktopLeftFooter }) => {
  const params = new URLSearchParams();
  params.delete("name");

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const { languageCode } = useContext(StateContext);

  const route = (r: string) => {
    searchParams.set("name", r);
    return searchParams.toString();
  };

  const defoultFooter = (
    <>
      <div className={classNames(styles.linksContainer)}>
        <Link
          className={classNames("inlineWhite", classes?.linkClassName)}
          to={`/legal/?${route("legal-and-privacy")}`}
        >
          {translations.legaAndPrivacy[languageCode]}
        </Link>
        <span className={classNames(styles.footerBulletPoint, classes?.linkClassName)}>&nbsp;&middot;&nbsp;</span>
        <Link
          to={`/legal/?${route("non-discrimination-notice")}`}
          className={classNames("inlineWhite", styles.link, classes?.linkClassName)}
        >
          {translations.NonDiscrimination[languageCode]}
        </Link>
      </div>
      <div className={classNames(styles.paragraph, classes?.textClassName)}>
        <p className={styles.paragraph}>
          A Division of Health Care Service Corporation, a Mutual Legal Reserve Company, an Independent Licensee of the
          Blue Cross and Blue Shield Association
        </p>
        <p className={classNames(styles.paragraph, classes?.textClassName)}>
          {translations.copyRight[languageCode](new Date().getFullYear())}
        </p>
      </div>
    </>
  );
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.footerContainer}>
        {footer && <div className={styles.content}>{footer}</div>}
        {!footer && !fullWidthFooter && (
          <>
            <div className={classNames(styles.footerContentLeft, classes?.footerContent)}>
              {desktopLeftFooter || defoultFooter}
            </div>
          </>
        )}
      </div>
    </footer>
  );
};
export default Footer;
